TrelloModel = require 'app/scripts/models/internal/trello-model'
_ = require 'underscore'

class Tag extends TrelloModel

  typeName: 'Tag'
  urlRoot: -> "#{ @getOrganization().url() }/tags"

  getOrganization: -> @collection.sourceModel

module.exports = Tag
